import styled from 'styled-components';
import Button from 'products/nomad_insurance/components/Button';

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  font-weight: 500;
`;

export const CodeWrapper = styled.div`
  max-width: 208px;
  margin-top: 8px;
`;

export const DoneButton = styled(Button)`
  align-self: flex-end;
`;
